/*
 * @Author: your name
 * @Date: 2022-03-02 14:09:24
 * @LastEditTime: 2022-03-18 11:23:43
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /streamline_detail/src/store/mutations.ts
 */
import { setState, state } from './index'
import { Coupons, CouponsNewUser } from '@/model/baseInfoResp'
export class Mutations {
  //更新领红包
  static updateRedPackState(v) {
    const coupons: Coupons[] = state.coupons || []
    coupons &&
      coupons.forEach((item, index) => {
        if (item.planId === v) {
          coupons[index].status = 1
        }
      })

    setState({
      coupons
    })

    if (state.couponsNewUser && state.couponsNewUser.length > 0) {
      const couponsNewUser: CouponsNewUser[] = state.couponsNewUser
      couponsNewUser.forEach((item, index) => {
        if (item.planId === v) {
          couponsNewUser[index].status = 1
        }
      })
      setState({
        couponsNewUser
      })
    }

    if (state.showCouponsNewUser) {
      const showCouponsNewUser: any = state.showCouponsNewUser
      showCouponsNewUser.status = 1
      setState({
        showCouponsNewUser
      })
    }
  }

  static updateCouponautoShow(v) {
    const newUserCouponPendant: any = state.newUserCouponPendant
    newUserCouponPendant.autoShow = v
    setState({
      newUserCouponPendant
    })
  }
}
